import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=c2523a86&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=c2523a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2523a86",
  null
  
)

export default component.exports